export default __webpack_public_path__ + "static/media/arrow.b79db10b.svg";